import { myAxios } from "./axios";

export function getAllInternalPayslips(filters, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(filters || {}),
    },
  };
  return myAxios.get("/internal-payslips", config);
}

export function getSingleInternalPayslip(id) {
  return myAxios.get("/internal-payslips/" + id);
}

export function addInternalPayslipe(data) {
  return myAxios.post("/internal-payslips/create", data);
}

export function deleteInternalPayslipe(id) {
  return myAxios.delete("/internal-payslips/" + id + "/delete");
}

export function sendInternalPayslipesEmail(data) {
  return myAxios.post("/internal-payslips/bulk-send", data);
}
